import React from "react";
import Icon from "@mdi/react";
import {
  mdiPencil,
  mdiCheckCircle,
  mdiCloseCircle,
  mdiClose,
  mdiBell,
  mdiClock,
  mdiCalendar,
  mdiClockOutline,
  mdiFormatListBulleted,
  mdiEmail,
  mdiPhone,
  mdiArrowLeftCircle,
  mdiArrowRightCircle,
  mdiCheckboxMarkedCircleOutline,
  mdiPlusCircleOutline,
  mdiCheck,
  mdiPlayCircleOutline,
  mdiRadioboxMarked,
  mdiRadioboxBlank
} from "@mdi/js";
import { theme } from "styles";

export const ICONSET_MAP = {
  pencil: mdiPencil,
  "check-circle": mdiCheckCircle,
  "close-circle": mdiCloseCircle,
  close: mdiClose,
  bell: mdiBell,
  clock: mdiClockOutline,
  calendar: mdiCalendar,
  list: mdiFormatListBulleted,
  email: mdiEmail,
  phone: mdiPhone,
  "arrow-left-circle": mdiArrowLeftCircle,
  "arrow-right-circle": mdiArrowRightCircle,
  "checkbox-marked-circle-outline": mdiCheckboxMarkedCircleOutline,
  "plus-circle-outline": mdiPlusCircleOutline,
  check: mdiCheck,
  "play-circle-outline": mdiPlayCircleOutline,
  "radiobox-marked": mdiRadioboxMarked,
  "radiobox-blank": mdiRadioboxBlank,
};

interface Props {
  name: keyof (typeof ICONSET_MAP);
  size?: number | string;
  color?: string;
  style?: any;
}

export default ({ name, size = 1, color = theme.colors.primary, style = {} }: Props) => {
  return (
    <Icon
      path={ICONSET_MAP[name] || mdiPencil}
      color={color}
      size={`${size}rem`}
      style={{
        ...style,
        height: `${size}rem`
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/ui/Icon.tsx